export default {
  googleTagManagerId: 'G-JP11SXWWGC',
  meta: {
    title: 'How Many Stamps?',
    titleSuffix: 'How Many Stamps?',
    description: `Find out how many stamps you'll need to post your letter or parcel through Royal Mail within the UK.`,
    keywords: `how many stamps royal mail uk postage letter parcel package`
  }
};